import actionCreatorFactory from "typescript-fsa";

const actionCreator = actionCreatorFactory();

export const updateDebugStatus = actionCreator<boolean>("UPDATE_DEBUG_STATUS");



// WEBPACK FOOTER //
// ./src/spread/model/debug/actions.ts